export default __webpack_public_path__ + "static/media/logo.3e7d6fd4.jpg";